var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-editor shape-editor",style:(_vm.blockStyle),attrs:{"id":_vm.blockId}},[_c('div',{staticClass:"shape",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }